import MusicCard from "../components/MusicCard"
import "../styles/all-musics.css"
import PageThree from "../pages/PageThree";

export default function AllMusics() {
    return (



        // <div className="musics">
        //     <MusicCard imageSource="https://mir-s3-cdn-cf.behance.net/projects/404/7142d3147154081.Y3JvcCwxMTQ4LDg5NywwLDQxMg.jpg" musicName="歌曲名" musicIntro="作者等介绍，背景图片可更换"/>
        //
        //     <MusicCard imageSource="https://mir-s3-cdn-cf.behance.net/projects/404/7142d3147154081.Y3JvcCwxMTQ4LDg5NywwLDQxMg.jpg" musicName="第三十八年夏至" musicIntro="第二首歌"/>
        //
        //     <MusicCard imageSource="https://mir-s3-cdn-cf.behance.net/projects/404/7142d3147154081.Y3JvcCwxMTQ4LDg5NywwLDQxMg.jpg" musicName="第三十八年夏至" musicIntro="第三首歌"/>
        //
        //     <MusicCard imageSource="https://mir-s3-cdn-cf.behance.net/projects/404/7142d3147154081.Y3JvcCwxMTQ4LDg5NywwLDQxMg.jpg" musicName="第三十八年夏至" musicIntro="第四首歌"/>
        //
        //     <MusicCard imageSource="https://mir-s3-cdn-cf.behance.net/projects/404/7142d3147154081.Y3JvcCwxMTQ4LDg5NywwLDQxMg.jpg" />
        //
        //     <MusicCard imageSource="https://mir-s3-cdn-cf.behance.net/projects/404/7142d3147154081.Y3JvcCwxMTQ4LDg5NywwLDQxMg.jpg" />
        //
        //     <MusicCard imageSource="https://mir-s3-cdn-cf.behance.net/projects/404/7142d3147154081.Y3JvcCwxMTQ4LDg5NywwLDQxMg.jpg" />
        //
        //
        // </div>

        <div style={{background: "rgb(32, 32, 48) ", height: document.documentElement.clientHeight}}>

            <div className="ms-5 text-light">
                <div>


                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <h1>This is Explore Music page.</h1>
                    <br/>
                    <h1>Coming Soon!</h1>
                </div>
            </div>
        </div>
    )
}